module.exports = __webpack_public_path__ + "media/unipod/installation_vertical_1-72058027.jpg";